/** Swedish & Norwegian builder UI strings (Danish in builderLabels.js). */

export const sv = {
  widgetBuilder: 'Widget-byggare',
  languageSection: 'Språk',
  interfaceLanguage: 'Builder-språk',
  interfaceLanguageHint: 'Menyer, knappar, texter och widget på din webbplats.',
  configure: 'Konfigurera',
  preview: 'Förhandsgranskning',
  embed: 'Inbäddning',
  myWidgets: 'Mina widgets',
  savedCount: '{count} sparade',
  newWidget: '+ Ny widget',
  noSavedYet: 'Inga sparade widgets än. Konfigurera nedan — sparas automatiskt.',
  newDraft: 'Nytt utkast — ändringar sparas automatiskt.',
  delete: 'Ta bort',
  deleteConfirm: 'Ta bort denna sparade widget?',
  untitled: 'Utan titel',
  changesInstant: 'Ändringar uppdaterar förhandsgranskningen direkt.',
  saving: 'Sparar…',
  unsavedChanges: 'Osparade ändringar…',
  saveError: 'Kunde inte spara till molnet. Starta om API-servern och försök igen.',
  savedCloud: 'Sparat i databasen.',
  savedLocal: 'Sparat lokalt (databas offline).',
  autoSaved: 'Auto-sparad {time}',
  changesAutoSave: 'Ändringar sparas automatiskt.',
  saveNow: 'Spara nu',
  widgetId: 'ID',
  widgetName: 'Widgetnamn',
  widgetType: 'Widgettyp',
  widgetLanguage: 'Widget-språk (inbäddning)',
  widgetLanguageHint: 'Språk besökare ser i widgeten. Redigera i src/i18n/widgetLabels.js',
  theme: 'Tema',
  themeRequired: 'Krävs vid skapande; behålls i inbäddning.',
  themeLight: 'Ljus',
  themeDark: 'Mörk',
  allowedDomains: 'Tillåtna domäner (inbäddning)',
  allowedDomainsHint:
    'En domän per rad. Tomt = alla sidor. localhost är alltid tillåtet i dev.',
  domainsPlaceholder: 'exempel.se\nwww.minblogg.se',
  accentColor: 'Accentfärg',
  hintTeamInjuries:
    'Använd lag-menyn ovanför förhandsgranskningen: Alla lag för lista per klubb, eller ett lag.',
  hintTeamPlayerList:
    'Välj ett lag i lag-menyn ovanför förhandsgranskningen för hela truppen med detaljer.',
  hintTeamProfile: 'Välj ett lag i lag-menyn ovanför förhandsgranskningen.',
  hintPlayerPicker: 'Välj en spelare i spelar-menyn ovanför förhandsgranskningen.',
  hintSelectMatchBar:
    'Välj match i Match-menyn i fältet ovan (bredvid Tävling). Auto väljer bästa tillgängliga match.',
  competition: 'Tävling',
  player: 'Spelare',
  team: 'Lag',
  match: 'Match',
  groupFeatured: 'Utvalda',
  groupAllLeagues: 'Alla ligor',
  groupSelection: 'Val',
  groupDefault: 'Standard',
  groupPlayers: 'Spelare',
  groupClubs: 'Klubbar i ligan',
  groupLive: 'Live',
  groupFinishedLineups: 'Avslutad — med uppställningar',
  groupFinished: 'Avslutad',
  groupUpcoming: 'Kommande',
  matchAuto: 'Auto (senaste / bäst tillgänglig)',
  matchAutoSub: 'Väljer live, sedan senaste avslutade match med data',
  topScorer: 'Skytteliga',
  teamAllGrouped: 'Alla lag (grupperade per klubb)',
  teamFirstInTable: 'Första i tabellen',
  hintTeamInjuriesPicker:
    'Alla lag visar varje klubb separat; välj en klubb för endast deras skadade spelare',
  hintTeamPlayerListPicker: 'Välj en klubb för att visa hela truppen med detaljer',
  hintTeamProfilePicker: 'Välj en klubb för lagprofils-widgeten',
  hintPlayerPickerBar: 'Välj en spelare för profil-widgeten',
  searchCompetitions: 'Sök tävlingar…',
  searchPlayers: 'Sök spelare…',
  searchTeams: 'Sök lag…',
  searchMatches: 'Sök matcher…',
  noCompetitions: 'Inga tävlingar hittades',
  noPlayer: 'Ingen spelare hittades',
  noTeam: 'Inget lag hittades',
  noMatches: 'Inga matcher matchar sökningen',
  loadingLeagues: 'Hämtar ligor…',
  competitionsFilter: '{count} tävlingar — skriv för att filtrera',
  loadingFixtures: 'Hämtar matcher från säsongsschema…',
  previewSelectedOnly: 'Förhandsgranskning visar endast vald match',
  matchesPick: '{count} matcher — välj omgång (uppställningar när tillgängliga)',
  noFixturesAuto: 'Inga matcher listade — auto-vald match används',
  loading: 'Laddar…',
  competitionsCount: '{count} tävlingar',
  embedCode: 'Inbäddningskod',
  embedIntro: 'Kopiera och klistra in på din sidas HTML.',
  embedThemeNote:
    'Tema: {theme}. Domän-whitelist under Konfigurera styr var embed får laddas.',
  copied: 'Kopierat!',
  copyEmbed: 'Kopiera inbäddningskod',
  openLiveEmbed: 'Öppna live embed-sida',
  openEmbedTest: 'Öppna embed-testsida',
  embedDevNote: 'Dev: URL använder localhost. Script-fliken laddar /embed.js.',
  embedWidgetId: 'Widget-ID',
  tabIframe: 'Iframe',
  tabScript: 'Script',
  cat_match: 'Match',
  cat_live: 'Live & schema',
  cat_league: 'Ligatabell',
  cat_team: 'Lag',
  cat_player: 'Spelare',
  cat_stats: 'Spelarstatistik',
  wt_match_card_label: 'Matchkort',
  wt_match_card_desc: 'Resultat, arena, mål, kort, tränare',
  wt_match_info_label: 'Matchinfo',
  wt_match_info_desc: 'Arena, publik, domare, tränare',
  wt_goals_list_label: 'Mållista',
  wt_goals_list_desc: 'Målskyttar för vald match',
  wt_match_events_label: 'Matchhändelser',
  wt_match_events_desc: 'Mål, kort, byten, VAR',
  wt_lineups_label: 'Uppställningar',
  wt_lineups_desc: 'Formationer, XI, kort, byten',
  wt_coach_card_label: 'Tränarkort',
  wt_coach_card_desc: 'Huvudtränare för en match',
  wt_live_scores_label: 'Livescore',
  wt_live_scores_desc: 'Live, kommande och resultat',
  wt_live_matches_label: 'Live nu',
  wt_live_matches_desc: 'Endast pågående matcher',
  wt_fixtures_label: 'Schema',
  wt_fixtures_desc: 'Kommande avspark',
  wt_results_label: 'Resultat',
  wt_results_desc: 'Avslutade matcher',
  wt_standings_label: 'Tabell',
  wt_standings_desc: 'Totalt, hemma och borta',
  wt_group_standings_label: 'Grupptabeller',
  wt_group_standings_desc: 'Gruppspel',
  wt_form_guide_label: 'Formguide',
  wt_form_guide_desc: 'Senaste form per lag',
  wt_team_stats_label: 'Mål för/emot',
  wt_team_stats_desc: 'Anfall och försvar från tabellen',
  wt_team_list_label: 'Laglista',
  wt_team_list_desc: 'Alla klubbar med placering och kvalifikation',
  wt_team_profile_label: 'Lagprofil',
  wt_team_profile_desc: 'Ett lag — statistik, form, europeiska platser',
  wt_player_list_label: 'Spelarlista',
  wt_player_list_desc: 'Hela truppen — ålder, nationalitet, position och statistik',
  wt_player_profile_label: 'Spelarprofil',
  wt_player_profile_desc: 'En spelare — mål, assist, matcher',
  wt_top_scorers_label: 'Skytteliga',
  wt_top_scorers_desc: 'Måltopplista',
  wt_top_assists_label: 'Assist',
  wt_top_assists_desc: 'Assisttopplista',
  wt_appearances_label: 'Matcher',
  wt_appearances_desc: 'Flest matcher spelade',
  wt_minutes_label: 'Minuter',
  wt_minutes_desc: 'Flest minuter på plan',
  wt_discipline_label: 'Kort',
  wt_discipline_desc: 'Gula och röda kort',
  wt_injuries_label: 'Skador',
  wt_injuries_desc: 'Spelare markerade som skadade',
};

export const no = {
  widgetBuilder: 'Widget-bygger',
  languageSection: 'Språk',
  interfaceLanguage: 'Builder-språk',
  interfaceLanguageHint: 'Menyer, knapper og tekster i denne appen.',
  widgetLanguageHintShort: 'Tekst i forhåndsvisningen og på nettstedet ditt.',
  configure: 'Konfigurer',
  preview: 'Forhåndsvisning',
  embed: 'Innbygging',
  myWidgets: 'Mine widgets',
  savedCount: '{count} lagret',
  newWidget: '+ Ny widget',
  noSavedYet: 'Ingen lagrede widgets ennå. Konfigurer nedenfor — lagres automatisk.',
  newDraft: 'Nytt utkast — endringer lagres automatisk.',
  delete: 'Slett',
  deleteConfirm: 'Slette denne lagrede widgeten?',
  untitled: 'Uten tittel',
  changesInstant: 'Endringer oppdaterer forhåndsvisningen med en gang.',
  saving: 'Lagrer…',
  unsavedChanges: 'Ulagrede endringer…',
  saveError: 'Kunne ikke lagre til skyen. Start API-serveren på nytt og prøv igjen.',
  savedCloud: 'Lagret i databasen.',
  savedLocal: 'Lagret lokalt (database offline).',
  autoSaved: 'Auto-lagret {time}',
  changesAutoSave: 'Endringer lagres automatisk.',
  saveNow: 'Lagre nå',
  widgetId: 'ID',
  widgetName: 'Widget-navn',
  widgetType: 'Widget-type',
  widgetLanguage: 'Widget-språk (innbygging)',
  widgetLanguageHint: 'Språk besøkende ser i widgeten. Rediger i src/i18n/widgetLabels.js',
  theme: 'Tema',
  themeRequired: 'Påkrevd ved opprettelse; beholdes i innbygging.',
  themeLight: 'Lys',
  themeDark: 'Mørk',
  allowedDomains: 'Tillatte domener (innbygging)',
  allowedDomainsHint:
    'Ett domene per linje. Tomt = alle sider. localhost er alltid tillatt i dev.',
  domainsPlaceholder: 'eksempel.no\nwww.minblogg.no',
  accentColor: 'Aksentfarge',
  hintTeamInjuries:
    'Bruk lag-menyen over forhåndsvisningen: Alle lag for liste per klubb, eller ett lag.',
  hintTeamPlayerList:
    'Velg et lag i lag-menyen over forhåndsvisningen for full tropp med detaljer.',
  hintTeamProfile: 'Velg et lag i lag-menyen over forhåndsvisningen.',
  hintPlayerPicker: 'Velg en spiller i spiller-menyen over forhåndsvisningen.',
  hintSelectMatchBar:
    'Velg kamp i Match-menyen i feltet over (ved siden av Turnering). Auto velger best tilgjengelige kamp.',
  competition: 'Turnering',
  player: 'Spiller',
  team: 'Lag',
  match: 'Kamp',
  groupFeatured: 'Utvalgte',
  groupAllLeagues: 'Alle ligaer',
  groupSelection: 'Valg',
  groupDefault: 'Standard',
  groupPlayers: 'Spillere',
  groupClubs: 'Klubber i ligaen',
  groupLive: 'Live',
  groupFinishedLineups: 'Avsluttet — med lagoppstillinger',
  groupFinished: 'Avsluttet',
  groupUpcoming: 'Kommende',
  matchAuto: 'Auto (siste / best tilgjengelig)',
  matchAutoSub: 'Velger live, deretter siste avsluttede kamp med data',
  topScorer: 'Toppscorer',
  teamAllGrouped: 'Alle lag (gruppert per klubb)',
  teamFirstInTable: 'Første i tabellen',
  hintTeamInjuriesPicker:
    'Alle lag viser hver klubb separat; velg én klubb for kun deres skadede spillere',
  hintTeamPlayerListPicker: 'Velg en klubb for å vise hele troppen med detaljer',
  hintTeamProfilePicker: 'Velg en klubb for lagprofil-widgeten',
  hintPlayerPickerBar: 'Velg en spiller for profil-widgeten',
  searchCompetitions: 'Søk turneringer…',
  searchPlayers: 'Søk spillere…',
  searchTeams: 'Søk lag…',
  searchMatches: 'Søk kamper…',
  noCompetitions: 'Ingen turneringer funnet',
  noPlayer: 'Ingen spiller funnet',
  noTeam: 'Ingen lag funnet',
  noMatches: 'Ingen kamper matcher søket',
  loadingLeagues: 'Henter ligaer…',
  competitionsFilter: '{count} turneringer — skriv for å filtrere',
  loadingFixtures: 'Henter kamper fra sesongprogram…',
  previewSelectedOnly: 'Forhåndsvisning viser kun valgt kamp',
  matchesPick: '{count} kamper — velg runde (lagoppstillinger når tilgjengelig)',
  noFixturesAuto: 'Ingen kamper listet — auto-valgt kamp brukes',
  loading: 'Laster…',
  competitionsCount: '{count} turneringer',
  embedCode: 'Innbyggingskode',
  embedIntro: 'Kopier og lim inn i sidens HTML.',
  embedThemeNote:
    'Tema: {theme}. Domene-whitelist under Konfigurer styrer hvor embed kan lastes.',
  copied: 'Kopiert!',
  copyEmbed: 'Kopier innbyggingskode',
  openLiveEmbed: 'Åpne live embed-side',
  openEmbedTest: 'Åpne embed-testside',
  embedDevNote: 'Dev: URL bruker localhost. Script-fanen laster /embed.js.',
  embedWidgetId: 'Widget-ID',
  tabIframe: 'Iframe',
  tabScript: 'Script',
  cat_match: 'Kamp',
  cat_live: 'Live & program',
  cat_league: 'Ligatabell',
  cat_team: 'Lag',
  cat_player: 'Spiller',
  cat_stats: 'Spillerstatistikk',
  wt_match_card_label: 'Kampkort',
  wt_match_card_desc: 'Resultat, stadion, mål, kort, trenere',
  wt_match_info_label: 'Kampinfo',
  wt_match_info_desc: 'Stadion, tilskuere, dommer, trenere',
  wt_goals_list_label: 'Målliste',
  wt_goals_list_desc: 'Målscorere for valgt kamp',
  wt_match_events_label: 'Kamphendelser',
  wt_match_events_desc: 'Mål, kort, bytter, VAR',
  wt_lineups_label: 'Lagoppstillinger',
  wt_lineups_desc: 'Formasjoner, XI, kort, bytter',
  wt_coach_card_label: 'Trenerkort',
  wt_coach_card_desc: 'Hovedtrenere for en kamp',
  wt_live_scores_label: 'Livescore',
  wt_live_scores_desc: 'Live, kommende og resultater',
  wt_live_matches_label: 'Live nå',
  wt_live_matches_desc: 'Kun kamper i gang',
  wt_fixtures_label: 'Program',
  wt_fixtures_desc: 'Kommende avspark',
  wt_results_label: 'Resultater',
  wt_results_desc: 'Avsluttede kamper',
  wt_standings_label: 'Tabell',
  wt_standings_desc: 'Samlet, hjemme og borte',
  wt_group_standings_label: 'Gruppeturnering',
  wt_group_standings_desc: 'Gruppespill',
  wt_form_guide_label: 'Formguide',
  wt_form_guide_desc: 'Siste form per lag',
  wt_team_stats_label: 'Mål for/mot',
  wt_team_stats_desc: 'Angrep og forsvar fra tabellen',
  wt_team_list_label: 'Lagliste',
  wt_team_list_desc: 'Alle klubber med plassering og kvalifisering',
  wt_team_profile_label: 'Lagprofil',
  wt_team_profile_desc: 'Ett lag — statistikk, form, europeiske plasser',
  wt_player_list_label: 'Spillerliste',
  wt_player_list_desc: 'Full tropp — alder, nasjonalitet, posisjon og statistikk',
  wt_player_profile_label: 'Spillerprofil',
  wt_player_profile_desc: 'Én spiller — mål, assist, kamper',
  wt_top_scorers_label: 'Toppscorere',
  wt_top_scorers_desc: 'Målrangering',
  wt_top_assists_label: 'Top assists',
  wt_top_assists_desc: 'Assistrangering',
  wt_appearances_label: 'Kamper',
  wt_appearances_desc: 'Flest kamper spilt',
  wt_minutes_label: 'Minutter',
  wt_minutes_desc: 'Flest minutter på banen',
  wt_discipline_label: 'Kort',
  wt_discipline_desc: 'Gule og røde kort',
  wt_injuries_label: 'Skader',
  wt_injuries_desc: 'Spillere markert som skadet',
};
